import { initializeGlobalState } from "@/modules/global-state/initializeGlobalState";

export const globalStateModule = {
  initialize: initializeGlobalState,
} as const;
